var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57505 6.31167L3.60418 6.2793L3.62853 6.24321C3.75514 6.0556 3.90167 5.87694 4.06839 5.71014L7.47545 2.30139C8.87661 0.899537 11.1482 0.899536 12.5494 2.30139L15.9299 5.68355C16.1204 5.87422 16.2847 6.08043 16.4229 6.29785L16.4477 6.33678L16.4779 6.37165C17.1151 7.1073 17.5 8.06568 17.5 9.11561V13.9328C17.5 16.2484 15.6239 18.125 13.3102 18.125H6.68981C4.37614 18.125 2.5 16.2484 2.5 13.9328V9.11561C2.5 8.037 2.90629 7.05485 3.57505 6.31167Z",
    stroke: "#495057",
    strokeWidth: 1.25
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 15,
    width: 7.5,
    height: 1.25,
    rx: 0.625,
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b9d21947fcd56f76b17dadae72e05857.svg";
export { ForwardRef as ReactComponent };